export const utils_search_childs = (id_container, id_input) => {
    const container = document.getElementById(id_container)
    const input = document.getElementById(id_input);
    if (container !== null && input !== null) {
        const filter = input.value.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        const a = container.children;
        for (let i = 0; i < a.length; i++)
            a[i].style.display = (a[i].textContent || a[i].innerText).toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').indexOf(filter) > -1 ? "" : "none";
    }
}